module.exports = __webpack_public_path__ + "img/wild.cc224410.png";